import { render, staticRenderFns } from "./BulkChangeTransactionsStatusModal.vue?vue&type=template&id=5f5a8858&"
import script from "./BulkChangeTransactionsStatusModal.vue?vue&type=script&lang=js&"
export * from "./BulkChangeTransactionsStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports